/** @format */

import React, {useContext, useState} from 'react';
import {QuoteContext} from 'frontier-quoter';
import withLocalHandler from './with_local_handler';
import SuperAgent from 'superagent';
import withUploadHandler from '../../../utilities/with_upload_handler';

import {IconButton} from '@sttark/design-system';
import UploadFile from 'frontier/ds/quoter/upload_file';

function AssetsUploader(props) {
    const {orderUploads, onClickAddFiles, fileProgress, dropping} = props;
    const orderUploadsByType = orderUploads.filter(upload => upload.type === props.uploadType);
    const hasUploads = orderUploadsByType.length > 0;

    const handleDelete = async (fileId, filepickerId) => {
        await SuperAgent.delete('/orders/delete-quote-order-uploads/' + fileId).set(
            'accept',
            'application/json'
        );

        props.onDelete(fileId, filepickerId);
    };

    return (
        <>
            <UploadFile
                multiple
                dropping={dropping}
                numUploaded={orderUploadsByType.length}
                numUploading={Object.keys(fileProgress).length}
                onClick={onClickAddFiles.bind(this)}
            />
            {hasUploads && (
                <>
                    <h5>Uploaded Files</h5>
                    <div className="border-y">
                        {orderUploadsByType.map(upload => (
                            <Asset
                                key={upload.filepicker_id}
                                uploadType={props.uploadType}
                                {...upload}
                                onDelete={handleDelete.bind(this, upload.id, upload.filepicker_id)}
                            />
                        ))}
                    </div>
                </>
            )}
        </>
    );
}

export default withLocalHandler(withUploadHandler(AssetsUploader));

const Asset = props => {
    return (
        <div className="hstack">
            <span className="ms-4 flex-grow-1">{props.filename}</span>
            <span className="font-body-xl">
                <IconButton
                    secondary
                    icon="zoomin"
                    onClick={() => window.open(props.filepicker_url)}
                />
                <IconButton secondary icon="trash" onClick={props.onDelete} />
            </span>
        </div>
    );
};
